import API from '../../../../../services/api';

export const DASHBOARD_PANTALLA_API = {
    get: async () => {
        return await API.get('/dashboard-pantalla/get-info').then(res => res.data);
    },
    refresh: async () => {
        return await API.get('/dashboard-pantalla/refresh-info').then(res => res.data);
    }
}
